import "../../exam/components/Layout/QuestionHeader/QuestionHeader.css";
import Bookmark from "../../../../shared/components/Bookmark/Bookmark";
import images from "../../../../utilities/images/images";
import { getExerciseQuestionTypeLabel } from "../utils/exerciseExamUtils";

const ExerciseLanguageToggle = ({ currentLang, onToggle, disabled }) => (
  <button
    onClick={onToggle}
    disabled={disabled}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      border: "none",
      background: "transparent",
      cursor: disabled ? "not-allowed" : "pointer",
      opacity: disabled ? 0.5 : 1,
      fontSize: "32px",
    }}
  >
    <span
      style={{
        fontSize: "14.4px",
        fontWeight: "bold",
        color: currentLang === "en" ? "orange" : "#555",
      }}
    >
      A
    </span>

    <span style={{ fontSize: "12px", color: "#555" }}>⇄</span>

    <span
      style={{
        fontSize: "14.4px",
        fontWeight: "bold",
        color: currentLang === "hi" ? "orange" : "#555",
      }}
    >
      अ
    </span>
  </button>
);

const ExerciseQuestionHeader = ({
  question,
  questionNumber,
  currentLang,
  onToggleLanguage,
  onToggleBookmark,
  isHindiAvailable,
  showBookmark = true,
}) => {
  const toughnessLabel = String(question?.toughness ?? "").trim();
  const isBookmarked = question?.marked === true;

  return (
    <div className="integration-container">
      <div className="integration-left">
        <span className="question-label">Q. {questionNumber}</span>
        <span className="question-divider"> | </span>
        <span className="question-type">
          {getExerciseQuestionTypeLabel(question) || "—"}
        </span>
        {toughnessLabel && (
          <span className="question-toughness-badge">{toughnessLabel}</span>
        )}
      </div>

      <div className="integration-right">
        {showBookmark && (
          <Bookmark
            bookmarked={isBookmarked}
            loading={false}
            onClick={onToggleBookmark}
            defaultImage={images.user_activity_bookmark_off}
            activeImage={images.user_activity_bookmark_on}
          />
        )}

        <ExerciseLanguageToggle
          currentLang={currentLang}
          onToggle={onToggleLanguage}
          disabled={!isHindiAvailable}
        />
      </div>
    </div>
  );
};

export default ExerciseQuestionHeader;
